import React from 'react';
import PropTypes from 'prop-types';
import MenuItem from './MenuItem';
import menuItems from '../data/menuItems';
import './Menu.css';

const Menu = props => {
  const sortedMenuItems = menuItems.map(menuItem => {
    const { classes, id, title, content } = menuItem;
    const { openContent } = props;
    return (
      <MenuItem
        key={id}
        classes={classes}
        openContent={openContent}
        content={content}
        title={title}
      />
    );
  });

  return (
    <div className='menu-wrapper'>
      <ul>{sortedMenuItems}</ul>
    </div>
  );
};
Menu.propTypes = {
  openContent: PropTypes.func,
};

Menu.defaultProps = {
  openContent: () => {},
};
export default Menu;
